/**
 * Base Data Service
 *
 * Provides functionality for common base data operations like dropdown lists
 * and member ID management.
 */

import {
    MemberIdPreviewRequest,
    MemberIdPreviewResponse, ParamTypeResponse,
    UpdateMemberIdSerialRequest,
    UpdateMemberIdSerialResponse
} from "../../../model";
import {DropdownRequest, DropdownResponse} from "../../../model";
import {CrudService} from "../../core/common/crud-service";

export class BaseDataService extends CrudService {

    /**
     * The base endpoint path for parameters
     */
    protected readonly basePath = '/api/base-data';

    async getParamTypes(): Promise<ParamTypeResponse[] | null> {
        return this.customGet('getParamType') || [];
    }

    /**
     * Get dropdown data based on parameter type
     */
    async getDropdown(request: DropdownRequest): Promise<DropdownResponse[] | null> {
        return this.customPost('getDropdown', request);
    }

    /**
     * Get preview of next member ID
     */
    async getNextMemberIdPreview(
        request: MemberIdPreviewRequest
    ): Promise<MemberIdPreviewResponse | null> {
        return this.customPost('getNextMemberIdPreview', request);
    }

    /**
     * Update member ID serial number
     */
    async updateMemberIdSerial(
        request: UpdateMemberIdSerialRequest
    ): Promise<UpdateMemberIdSerialResponse | null> {
        return this.customPost('updateMemberIdSerial', request);
    }
}

// Export a singleton instance
export const baseDataService = new BaseDataService();
